"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CDNURLMappings = void 0;
exports.CDNURLMappings = {
    'config.storyverse.xyz': 'd3ar4smkmrrv66.cloudfront.net',
    'cms.stories.storyverse.xyz': 'd28jmew06dfb81.cloudfront.net',
    'cms.stories.beta.pnk.one': 'dykzsi943bnpb.cloudfront.net',
    'media.storyverse.xyz': 'd3sdkpy3gufblo.cloudfront.net',
    'media.pnk.one': 'd3iyi81ue9o8rz.cloudfront.net',
    'cms.characters.alpha.storyverse.xyz': 'd1dsnn0jjeb2tf.cloudfront.net',
    'cms.characters.alpha.pnk.one': 'd3cqqmd0xdyrn0.cloudfront.net',
    'covers.alpha.storyverse.xyz': 'd137j1lhcz3va4.cloudfront.net',
    'covers.alpha.pnk.one': 'd3d19t5i6yt4c9.cloudfront.net'
};
//# sourceMappingURL=cdnUrlMappings.js.map